import { useState } from 'react';

import Tile from 'components/shared/others/tile/tile';
import PowerBiReport from 'components/shared/others/power-bi-report/power-bi-report';
import NotificationMessage from 'components/partials/notification/notification';

import { useReports } from 'hooks/api/use-reports';

import { REPORT_TYPES } from 'constants/reports';

interface DashboardReport {
  id: string | number;
  powerBiId: string;
  powerBiReportType?: string;
}

interface ReportError {
  data: {
    title: string;
    status: number | string;
  };
}

interface ChartTileProps {
  report?: DashboardReport | null;
  onError: (error: unknown) => unknown;
}

const ChartTile = ({ report, onError }: ChartTileProps): React.JSX.Element => (
  <Tile customClass="w-full !p-0" dataTestId="chart-tile">
    {!report ? (
      'Unavailable'
    ) : (
      <PowerBiReport
        onError={onError}
        reportId={report.powerBiId}
        constrainToViewport={false}
        customClass="w-full h-[1098px]"
      />
    )}
  </Tile>
);

const HomeReportTiles = (): React.JSX.Element => {
  const [error, setError] = useState<ReportError | undefined>();
  const reports = useReports();

  const handleError = (error: unknown): unknown => {
    setError(error as ReportError);

    return error;
  };

  const reportsList = reports.data as DashboardReport[] | null | undefined;

  const dashboard_1 = Array.isArray(reportsList)
    ? reportsList.find(
        (report) => report?.powerBiReportType === REPORT_TYPES.DASHBOARD_1,
      )
    : null;

  return error ? (
    <NotificationMessage
      customClass="mb-6"
      heading={error.data.title}
      variant="error"
      message={`Error loading reports (${error.data.status} ${error.data.title})`}
    />
  ) : (
    <>
      <div className="flex flex-col md:flex-row w-full min-h-[300px]">
        <ChartTile report={dashboard_1} onError={handleError} />
      </div>
    </>
  );
};

export default HomeReportTiles;
